import { TypedAsyncCommandHandler } from '@/lib/web-api/apiClasses/TypedAsyncCommandHandler'
import { ClientFlowApi } from './ClientFlowApi'
/**
 * A class that handles executing of ClientFlow commands and can be
 * instantiated with functions to run `before`, `after`, `onSuccess`
 * and `onError`. Check out the base class `TypedAsyncCommandHandler`
 * for more documentation.
 *
 * example usage:
 * ```ts
    const myHandler = new Handler({
      before: () => () => console.log('before'),
    })
    // ...
    const cmd = myApi.sayHi('Bob') // <- some dummy example
    // This will return the result of cmd.exec() and
    // also run `before` function:
    const res = myHandler.handle(cmd)
 ```
 */
export class Handler extends TypedAsyncCommandHandler<ClientFlowApi> { }
